// admin-frontend/src/actions/timeline.actions.js
import axios from '../helpers/axios';
import { timelineConstants } from './constants';

export const fetchTimeline = (
    chatId,
    { before, limit = 15, append = false, q, dateFrom, dateTo, only } = {}
) => async (dispatch) => {
    console.log('🐞 [TL] fetchTimeline chatId=%s before=%s limit=%s append=%s q="%s" only=%s',
        chatId, before || '—', limit, append, q || '—', only || '—');

    dispatch({ type: timelineConstants.FETCH_REQUEST, chatId });
    try {
        const params = new URLSearchParams({ limit: String(limit) });
        if (before) params.set('before', before);
        if (q) params.set('q', q);
        if (dateFrom) params.set('dateFrom', dateFrom);
        if (dateTo) params.set('dateTo', dateTo);
        if (only) params.set('only', only);

        const url = `/chat/${chatId}/timeline?` + params.toString();
        const { data } = await axios.get(url);
        console.log('🟢 [TL] fetched items=%d nextCursor? %s', data?.items?.length || 0, !!data?.nextCursor);
        dispatch({ type: timelineConstants.FETCH_SUCCESS, chatId, payload: data, meta: { append } });
    } catch (e) {
        console.error('🔴 [TL] fetch error:', e?.message || e);
        dispatch({ type: timelineConstants.FETCH_FAILURE, chatId, error: e?.message || 'Ошибка загрузки' });
    }
};

export const clearTimeline = (chatId) => {
    console.log('🐞 [TL] clear chatId=%s', chatId);
    return { type: timelineConstants.CLEAR, chatId };
};

export const appendRealtimeCall = (chatId, item) => {
    console.log('🟢 [TL] append realtime item type=%s id=%s', item?.type, item?._id);
    return { type: timelineConstants.APPEND_REALTIME, chatId, item };
};

export const markReadLocal = (chatId, userId) => ({
    type: timelineConstants.MARK_READ_LOCAL, chatId, userId
});

export const deleteMessageLocal = (chatId, messageId) => ({
    type: timelineConstants.DELETE_MESSAGE_LOCAL, chatId, messageId
});
